import FilterContent from "../../../../components/Filter/FilterContent";
import PopOver from "../../../../components/View/PopOver";
import { IconAdjustmentsHorizontal, IconX } from "@tabler/icons-react";
import { Button, Group, Indicator, Tooltip } from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useLeadsStore } from "../../../../stores/LeadsStore";
import { transformFilterToServer, transformServerToFilter } from "../../../../functions/utilFunctions";
import { useCallback } from "react";

const LeadsTableFilter = ({ tableFilter, setTableFilter }) => {
  const lang = useLanguage((s) => s.language);
  const filters = useLeadsStore((s) => s.filters);

  const filter = transformFilterToServer(tableFilter)

  const handleClear = useCallback(() => {
    setTableFilter({
      "items": [],
      "logicOperator": "and",
      "quickFilterValues": []
    });
  }, [setTableFilter]);

  const handleNewFilter = useCallback((newFilter, handleClose) => {
    setTableFilter(transformServerToFilter(newFilter));
    handleClose();
  }, [setTableFilter]);

  return (
    <Group gap={0} ml={16}>
      <PopOver
        opener={(openFunction, ref) => {
          return (
            <Group gap={0}>
              <Tooltip label={lang.table.toolbar.filter.main_button_tooltip}>
                <Button
                  ref={ref}
                  onClick={openFunction}
                  radius={"md"}
                  variant={"subtle"}
                  className="test"
                  style={{
                    borderColor: "var(--mantine-color-primary-0)",
                    background: "#fff",
                    borderTopRightRadius: filter?.values?.length > 0 ? 0 : 8,
                    borderBottomRightRadius: filter?.values?.length > 0 ? 0 : 8,
                  }}
                  id={"table-filter-prm"}
                >
                  <Indicator
                    color="red"
                    offset={2}
                    disabled={!filter || filter?.values?.length === 0}
                    label={filter?.values?.length}
                    styles={{
                      indicator: {
                        fontSize: 9,
                        padding: "6px",
                      },
                    }}
                  >
                    <IconAdjustmentsHorizontal size={20} />
                  </Indicator>
                  <span style={{ marginLeft: 6 }}>
                    {lang.table.toolbar.filter.main_button_label}
                  </span>
                </Button>
              </Tooltip>
              {filter?.values?.length > 0 && (
                <Tooltip
                  label={lang.table.toolbar.filter.cancel_button_tooltip}
                >
                  <Button
                    variant="light"
                    color="red"
                    px={4}
                    style={{
                      borderLeft: "none",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                    }}
                    onClick={handleClear}
                  >
                    <IconX size={18} />
                  </Button>
                </Tooltip>
              )}
            </Group>
          );
        }}
        popoverChildren={(handleClose) => (
          <FilterContent
            id={"leads-filter"}
            pageName={"prm"}
            isClient={false}
            mainFilter={filter}
            setMainFilter={(f) => handleNewFilter(f, handleClose)}
            fields={filters}
            getFieldOptionName={(f) => f.option_name}
          />
        )}
        elevation={3}
        paperSx={{
          ml: -12,
        }}
      />
    </Group>
  );
};

export default LeadsTableFilter;
